module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAj0lEQVRYR+2W0QnAIAxEL1t1kTpIB+kgdZFulRJIf0QwCCVtuYBfRnM+9VSQHJJcHxTwXQKqugKwZlFFpM6cp2kCLuDwooUCSIAE/kXA7/jIVxYAmyftAM7RgB6lrhGpqhnM7XKjeaP95palTX6tgMjqn9uCCFO+BSRAAiSQ/imNmFUkZ/pXHJk8kkMB6QQuwEZwIeLx4wcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/加号.png
// module id = fPGI
// module chunks = 171